/**
 * Settings › "New layout (beta)": the person's switch between the classic layout and the new one (one Lykke on
 * every screen). Shown where the person may switch (staff anywhere; everyone on staging).
 */
import { Check } from 'lucide-react';
import { useNewLayout } from './useNewLayout';

export function NewLayoutSetting() {
  const layout = useNewLayout();
  if (!layout.mayToggle) return null;
  return (
    <div className="mt-5 space-y-3 border-t border-gray-100 pt-5" data-new-layout-setting>
      <label className="group flex cursor-pointer items-start gap-3">
        <button type="button" role="switch" aria-checked={layout.on} onClick={() => layout.set(!layout.on)}
          className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-md border-2 transition-all ${layout.on ? 'border-[#be43ff] bg-[#be43ff]' : 'border-gray-300 bg-white group-hover:border-gray-400'}`}>
          {layout.on && <Check className="h-3 w-3 text-white" strokeWidth={3} />}
        </button>
        <span className="flex flex-col">
          <span className="text-sm text-[#344054]">New layout (beta)</span>
          <span className="text-xs text-[#667085]">Lykke on every screen beside your work, a sidebar you can pin or fold away, and a calm workspace. Switch back any time.</span>
        </span>
      </label>
    </div>
  );
}
